import { Component, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { MatDialogRef } from '@angular/material/dialog'
import { AddExpense, AttachmentService, ConfirmDialogService } from '@tokeet-frontend/tv3-platform'
import { Store } from '@ngrx/store'
import { ExpenseDialog, getExpensePayloadFromForm } from '../../shared/dialogs/expense-dialog.abstract'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { AuthService } from '@tv3/services/auth.service'

@Component({
  selector: 'app-add-expense-dialog',
  templateUrl: '../../shared/dialogs/expense-dialog.component.html',
  styleUrls: ['../../shared/dialogs/expense-dialog.component.scss'],
  host: { class: 'modal-content' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddExpenseDialogComponent extends ExpenseDialog {
  title = $localize`Add Expense`

  get rentalTooltip() {
    return this.isEdit
      ? $localize`Change the rental associated with this expense.`
      : $localize`Choose a Rental to link this expense to.`
  }

  get categoryTooltip() {
    return this.isEdit
      ? $localize`Change the category or create a new one by deleting the existing data and typing into the field below.`
      : $localize`Choose a category or create a new one by typing into the field below.`
  }

  get inquiryTooltip() {
    return this.isEdit
      ? $localize`Change the inquiry this expense is associated with.`
      : $localize`Associate this expense with an inquiry. This step is not required.`
  }

  constructor(
    public dialogRef: MatDialogRef<AddExpenseDialogComponent>,
    protected fb: UntypedFormBuilder,
    protected authService: AuthService,
    protected attachmentService: AttachmentService,
    protected store: Store<any>,
    protected confirm: ConfirmDialogService,
    private amplitudeService: AmplitudeService
  ) {
    super(fb, authService, attachmentService, store, confirm)
  }

  close() {
    this.dialogRef.close()
  }

  onSave(form: UntypedFormGroup) {
    this.store.dispatch(
      AddExpense({
        payload: {
          ...getExpensePayloadFromForm(form),
          attachments: this.attachments.map((t) => t.id),
        },
      })
    )
    this.amplitudeService.logEvent('expenses-create-save')
    this.close()
  }
}
